import * as zod from 'zod'

export const createTimeClockFlowSchema = zod.object({
  companyId: zod.number({
    invalid_type_error: 'Company is required',
    required_error: 'Company is required',
  }),
  locationId: zod.number({
    invalid_type_error: 'Location is required',
    required_error: 'Location is required',
  }),
  vendorClockId: zod
    .string()
    .trim()
    .min(1, { message: 'Vendor clock id is required' }),
  manufacturer: zod
    .string()
    .trim()
    .min(1, { message: 'Manufacturer is required' }),
  model: zod.string().trim().min(1, { message: 'Model is required' }),
})

export type CreateTimeClockFlowSchema = zod.infer<
  typeof createTimeClockFlowSchema
>
